var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-holder ww"},[_c('v-alert',{staticClass:"alertComponent",attrs:{"type":_vm.getType}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataAlert.message)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }